
document.addEventListener('DOMContentLoaded', () => {
    const StickyBannerImgs = document.querySelectorAll('.AboutUs__ImageWithText .custom-section-content .section-content-wrapper .image-block > img');
    const StickyBannerObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.scale = 1;
            } 
        });
    }, {
        threshold: 0.5,             
        rootMargin: '0px 0px 20% 0px'
    });
    StickyBannerImgs.forEach(StickyBannerImg => {
        StickyBannerObserver.observe(StickyBannerImg);
    });

    
    if(document.querySelector('.sticky-header .sticky-cart-icon')) {
        document.querySelector('.sticky-header .sticky-cart-icon').addEventListener('click', () => {
            document.querySelector('header-actions cart-drawer-component.cart-drawer .button.header-actions__action').click();
        });
    }

    // On variant change   ---------------
    if (document.querySelectorAll('.variant_key_feature_container .key_feature').length > 0 ) {
        const urlParams = new URLSearchParams(window.location.search);
        const urlVariantId = urlParams.get('variant');
        if (urlVariantId) {
            const targetElement = document.querySelector(`.variant_key_feature_container[id="${urlVariantId}"]`);
            if (targetElement) {
                targetElement.style.display = 'block';
            }
        } else {
            const firstElement = document.querySelector('.variant_key_feature_container');
            if (firstElement) {
                firstElement.style.display = 'block';
            }
        }
    }

    const InputVariants = document.querySelectorAll('.variant-option .variant-option__button-label > input[data-variant-id]');
    if (InputVariants && InputVariants.length > 0) {
        InputVariants.forEach(inputElem => {
            inputElem.onclick = function() {
                const dataVarId = inputElem.getAttribute('data-variant-id');
                const variantSku = inputElem.getAttribute('data-sku');
                const skuElement = document.querySelector('.product-details .product-sku span');
                if (skuElement) {
                    skuElement.textContent = variantSku;
                }

                if (document.querySelectorAll('.variant_key_feature_container .key_feature').length > 0 ) {
                    document.querySelectorAll('.variant_key_feature_container').forEach(el => el.style.display = 'none');
                    const targetElement = document.querySelector(`.variant_key_feature_container[id="${dataVarId}"]`);
                    if (targetElement) {
                        targetElement.style.display = 'block';
                    }
                }

            }
        })
    }

const cartBtn = document.querySelector('.loyality_addproduct .add-to-cart-button');

  function toggleCartButton() {
    const points = Number(window?.AVADA_JOY?.points) || 0;
    
    if (!cartBtn) return;

    if (points >= 50) {
      cartBtn.disabled = false;
      cartBtn.classList.remove('disabled');
    } else {
      cartBtn.disabled = true;
      cartBtn.classList.add('disabled');
    }
  }

  toggleCartButton();

  const interval = setInterval(() => {
    if (window?.AVADA_JOY?.points !== undefined) {
      toggleCartButton();
      clearInterval(interval);
    }
  }, 500);
    
});
 
